// extracted by mini-css-extract-plugin
export default {"background":"hero_background__jptZ0","container":"hero_container__Nq1vv","heading":"hero_heading__q+IoP","title":"hero_title__noikc","details":"hero_details__Po9Wg"};